import Axios from '../axios'
import appConfig from '../../../app.config'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'

export interface CustomerIban {
	senderIban: string
	senderBic: string
}

export async function getIbans(customerId: string) {
	return Axios.get<CustomerIban[]>(
		`${appConfig.customerDataBaseUrl}/api/CreditCard/ibans/${customerId}`,
		await getHeadersWithJwtToken(),
	)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
